import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
export const updateDropMnemonicIdEndpoint = {
    [dropEndpointIds.UPDATE_DROP_MNEMONIC_ID]: {
        endpointType: otherEndpointType,
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
                newMnemonicId: { type: 'string' },
            },
            required: ['dropId', 'newMnemonicId'],
        },
    },
};
